import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';

class RoadmapStrategyRoadmapViewGridRoute extends Route {
  @service router;
  @service roadmap;

  beforeModel() {
    const model = this.modelFor('roadmap.strategy.roadmap');
    this.roadmap.setId(model.id);
    this.router.transitionTo('planning.dashboard.grid');
  }

  model() {
    return this.modelFor('roadmap.strategy.roadmap');
  }
}

export default instrumentRoutePerformance(RoadmapStrategyRoadmapViewGridRoute);
